"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKYCFormComponent = void 0;
var _KYC_IMLegacyForm = _interopRequireDefault(require("../KYC_IMLegacy/KYC_IMLegacyForm"));
var _KYC_IMForm = _interopRequireDefault(require("../KYC_IM/KYC_IMForm"));
var _KYC_ManualForm = _interopRequireDefault(require("../KYC_Manual/KYC_ManualForm"));
var _KYC_ManualIframe = _interopRequireDefault(require("../KYC_Manual/KYC_ManualIframe"));
var _KYC_JumioIframe = _interopRequireDefault(require("../KYC_Jumio/KYC_JumioIframe"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getKYCFormComponent = exports.getKYCFormComponent = function getKYCFormComponent(kycConfig) {
  switch (kycConfig.type) {
    case 'IM':
    case 'IMLegacy':
      return _KYC_IMLegacyForm["default"];
    case 'IM3.2':
      return _KYC_IMForm["default"];
    case 'Jumio':
      return _KYC_JumioIframe["default"];
    case 'Manual':
      return _KYC_ManualForm["default"];
    case 'HTML':
      return _KYC_ManualIframe["default"];
    default:
      return null;
  }
};